import { Col, Descriptions, List, Row, Space, Tag } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";

import Report, { AuthState } from "../../store/multivers/report";

interface Props {
  report: Report;
}

const ReportDetail = (props: Props) => {
  const { report } = props;
  const { brand, deviceYearClass, manufacturer, modelName, osName, osVersion } =
    report.data?.device || {};
  const { t } = useTranslation();
  const { state, employee, userId, invitation, confirmation, phone, url } =
    (report.data?.auth as any) || {};

  return (
    <Space direction="vertical">
      <Descriptions title={t("Log")} />
      <List
        dataSource={report.data.log.slice()}
        renderItem={(message) => (
          <List.Item>
            <Row>
              <Col>{message.text}</Col>
            </Row>
            <Row>
              <Tag
                color={
                  message.type === "tag"
                    ? "orange"
                    : message.type === "error"
                    ? "red"
                    : undefined
                }
              >
                {message.type}
              </Tag>
            </Row>
          </List.Item>
        )}
      />
      <Descriptions title={t("Device")} column={1}>
        <Descriptions.Item label={t("Brand")}>{brand}</Descriptions.Item>
        <Descriptions.Item label={t("Manufacturer")}>
          {manufacturer}
        </Descriptions.Item>
        <Descriptions.Item label={t("Model")}>{modelName}</Descriptions.Item>
        <Descriptions.Item label={t("OS")}>{osName}</Descriptions.Item>
        <Descriptions.Item label={t("Version")}>{osVersion}</Descriptions.Item>
        <Descriptions.Item label={t("Year")}>
          {deviceYearClass}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions title={t("Details")} column={1}>
        <Descriptions.Item label={t("State")}>
          {state === AuthState.Intitial
            ? t("Initial")
            : state === AuthState.ConfirmationStarted
            ? t("Confirmation")
            : state === AuthState.InvitationStarted
            ? t("Invitation")
            : state === AuthState.SignedIn
            ? t("Signed in")
            : state === AuthState.Deeplink
            ? t("Deeplink")
            : ""}
        </Descriptions.Item>
        {employee && (
          <Descriptions.Item label={t("Employee")}>
            {employee}
          </Descriptions.Item>
        )}
        {userId && (
          <Descriptions.Item label={t("UserId")}>{userId}</Descriptions.Item>
        )}
        {invitation && (
          <Descriptions.Item label={t("Invitation")}>
            {invitation}
          </Descriptions.Item>
        )}
        {confirmation && (
          <Descriptions.Item label={t("Confirmation")}>
            {confirmation}
          </Descriptions.Item>
        )}
        {phone && (
          <Descriptions.Item label={t("Phone")}>{phone}</Descriptions.Item>
        )}
        {url && <Descriptions.Item label={t("URL")}>{url}</Descriptions.Item>}
      </Descriptions>
    </Space>
  );
};

export default observer(ReportDetail);
